import {UrlBase} from "@/config/base.config";
import store from '../store/index'
import axios, {AxiosInstance, AxiosRequestConfig} from "axios";

export class EntityService {

	axiosObj: AxiosInstance

	constructor() {
		this.axiosObj = axios.create({
			baseURL: UrlBase,
			timeout: 10000
		});
	}

	async getList(entity: string) {
		try {
			const config: AxiosRequestConfig = {
				headers: { Authorization: `Bearer ${store.state.token}`}
			}
			const list = await this.axiosObj.get(entity, config)
			return list.data
		} catch (e) {
			if (e.response && e.response.data && e.response.data.message) throw new Error(e.response.data.message)
			else  throw new Error(e)
		}
	}

	async createEntity(entity: string, form: object) {
		try {
			const config: AxiosRequestConfig = {
				headers: { Authorization: `Bearer ${store.state.token}`}
			}
			const response = await this.axiosObj.post(entity, form, config)
			return response.data
		} catch (e) {
			if (e.response && e.response.data && e.response.data.message) throw new Error(e.response.data.message)
			else  throw new Error(e)
		}
	}

	async updateEntity(entity: string, form: object) {
		try {
			const config: AxiosRequestConfig = {
				headers: { Authorization: `Bearer ${store.state.token}`}
			}
			const response = await this.axiosObj.put(entity, form, config)
			return response.data
		} catch (e) {
			if (e.response && e.response.data && e.response.data.message) throw new Error(e.response.data.message)
			else  throw new Error(e)
		}
	}

	async uploadFile(entity: string, url: string, file: Blob) {
		try {
			const config: AxiosRequestConfig = {
				headers: { Authorization: `Bearer ${store.state.token}`}
			}
			const form = new FormData()
			form.append('file', file)
			const response = await this.axiosObj.post(`${entity}/${url}`, form, config)
			return response.data
		} catch (e) {
			if (e.response && e.response.data && e.response.data.message) throw new Error(e.response.data.message)
			else  throw new Error(e)
		}
	}

	async makeEntityAction(entity: string, id: number, action: string, form?: object|null) {
		try {
			const config: AxiosRequestConfig = {
				headers: { Authorization: `Bearer ${store.state.token}`}
			}
			const response = await this.axiosObj.post(`${entity}/${id}/${action}`, form, config)
			return response.data
		} catch (e) {
			if (e.response && e.response.data && e.response.data.message) throw new Error(e.response.data.message)
			else  throw new Error(e)
		}
	}

}
